import { styled } from '@pata-app/themes';

export const BenefitTileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    fill: ${({ theme }) => theme.core.colors.primary.green.medium};
  }
`;

export const BenefitTitle = styled.h3`
  font-size: ${({ theme }) => theme.core.fontSizes.xxl}px;

  color: ${({ theme }) => theme.core.colors.primary.green.medium};

  margin-top: ${({ theme }) => theme.core.sizing[3]}px;
  margin-bottom: ${({ theme }) => theme.core.sizing[1]}px;

  text-align: center;
`;

export const BenefitDescription = styled.p`
  margin: 0;

  text-align: center;
`;

export const SectionHeading = styled.h2`
  margin-bottom: ${({ theme }) => theme.core.sizing[2]}px;

  font-size: ${({ theme }) => theme.core.fontSizes.xxxl}px;
  text-align: left;

  margin: 0;
`;
